import { useTranslation } from "next-i18next";

import { HelpHeadingTocItem } from "@/common/utils/help/help-html.utils";
import { Heading } from "@/ui/cva/Heading";
import { Body } from "@/ui/typography/Body";

type HelpOnThisPageProps = {
  headings: HelpHeadingTocItem[];
};

export const HelpOnThisPage = ({ headings }: HelpOnThisPageProps) => {
  const { t } = useTranslation("common");

  if (headings.length < 2) {
    return null;
  }

  const title = t("help-on-this-page", "On this page");

  const list = (
    <ul className="mt-2 flex flex-col gap-y-1">
      {headings.map(heading => (
        <li
          key={heading.id}
          className={heading.level === 3 ? "pl-4" : undefined}
        >
          <a
            href={`#${heading.id}`}
            className="text-brand-500 underline focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200"
          >
            <Body as="span" className="text-brand-500">
              {heading.text}
            </Body>
          </a>
        </li>
      ))}
    </ul>
  );

  return (
    <nav aria-label={title} className="mt-6">
      <details className="md:hidden">
        <summary className="cursor-pointer font-title text-base font-bold text-black">
          {title}
        </summary>
        {list}
      </details>
      <div className="hidden md:block">
        <Heading as="h2" size="h5">
          {title}
        </Heading>
        {list}
      </div>
    </nav>
  );
};
